module.exports = __webpack_public_path__ + "img/operation-locker.71326b08.jpg";